import { angularAMD } from "@pebblepad/amd";
import { react2angular } from "@pebblepad/react2angular";
import { DialogView } from "@pjs/core-ui";

angularAMD.component("dialogView", react2angular(DialogView));
